import React, {Component} from "react"
import styles from "./Footer.module.css"
import dewhvactrainingscLogo from "../Header/parts/img/dew-logo.png"

const campuses = [
    {
        id: 1,
        region_id: 1,
        name: "Summerville",
        code: "Summerville",
        address: "Summerville, SC 29483 - 4648, 103 Ardis Street Unit A",
        state: "",
        phone: "1-833-DEWACSC (339-2272)",
        school_code: "",
        region: {
            id: 1,
            state: "South Carolina",
            region: "South Carolina"
        }
    }
]

const social = [
    {
        id: 1,
        name: "Facebook",
        link: "https://www.facebook.com/dewhvactrainingsc",
        icon: "fa fa-facebook"
    },
    {
        id: 2,
        name: "Instagram",
        link: "http://instagram.com/dewhvactrainingsc",
        icon: "fa fa-instagram"
    },
    {
        id: 3,
        name: "Twitter",
        link: "https://x.com/dewhvactraining",
        icon: "fa fa-twitter"
    },
    {
        id: 4,
        name: "Youtube",
        link: "https://www.youtube.com/@DEWHVACTRAININGSC",
        icon: "fa fa-youtube-play"
    }
]

interface Props {}

export class Footer extends Component<Props, {}> {
    public render() {
        return (
            <footer className={styles.root}>
                <div className={styles.wrapper}>
                    <div>
                        <div>
                            <img
                                className={styles.logo}
                                src={dewhvactrainingscLogo}
                                alt="dewhvactrainingsc-logo"
                            />
                        </div>
                        <div className={styles.social}>
                            {social.map(({id, link, icon}) => (
                                <a
                                    href={link}
                                    className={icon}
                                    key={id}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    {""}
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className={styles.campuses}>
                        <h5>
                            <strong>Campus Location:</strong>
                        </h5>
                        {campuses.map(({code, address, phone, id}) => (
                            <div className={styles.campusContainer} key={id}>
                                <div className={styles.code}>
                                    <strong>{code}</strong>
                                </div>
                                <div className={styles.address}>{address}</div>
                                <div className={styles.phone}>
                                    <strong>Ph:</strong> {phone}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </footer>
        )
    }
}
